export const getDomainWithoutSubdomain = (url: any) => {
    const urlParts = (url).split('.')

    return urlParts
        .slice(0)
        .slice(-(urlParts.length === 4 ? 3 : 2))
        .join('.')
}